import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import TripInviteModal from "./TripInviteModal";

const TripInvitePage = () => {
  const navigate = useNavigate();
  const { travelKeyToken } = useParams();

  return (
    <TripInviteModal
      isOpen={true}
      onClose={() => navigate(-1)}
      travelKeyToken={travelKeyToken}
    />
  );
};

export default TripInvitePage;